import { useMutation } from '@tanstack/react-query';
import api from 'services/api';

const useCancelReport = () => {
  const cancel = async ({ experimentId }) => {
    const res = await api.get(
      `api/v1/trials/experiments/${experimentId}/report/cancel`
    );
    return res.data;
  };

  return useMutation({
    mutationFn: cancel,
  });
};

export default useCancelReport;
